import React, { useEffect } from "react"
import NotificationFrom from "./Notifications/notificationForm"
import CustomEmailForm from "./CustomEmails/customEmailForm"
import { connect } from "react-redux"
import { getCommunication, resetCommunication } from "store/actions"
import { LoadingIndicator } from "components/LoadingIndicator"

const EditCommunication = ({
  communication,
  getCommunication,
  loading,
  match,
  resetCommunication,
}) => {
  useEffect(() => {
    if (match.params.id) {
      getCommunication(match.params.id)
    }
    return () => {
      resetCommunication()
    }
  }, [])

  return (
    <React.Fragment>
      {loading ? (
        <LoadingIndicator />
      ) : communication?.communication_type === 3 ? (
        <CustomEmailForm communication={communication} />
      ) : (
        <NotificationFrom communication={communication} />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  communication: state.Communications.communication,
  loading: state.Communications.loading,
})

const mapDispatchToProps = dispatch => ({
  getCommunication: values => dispatch(getCommunication(values)),
  resetCommunication: () => dispatch(resetCommunication()),
})

export default connect(mapStateToProps, mapDispatchToProps)(EditCommunication)
